import { render } from "./InsuranceForm.vue?vue&type=template&id=6d825086"
import script from "./InsuranceForm.vue?vue&type=script&lang=js"
export * from "./InsuranceForm.vue?vue&type=script&lang=js"

import "./InsuranceForm.vue?vue&type=style&index=0&id=6d825086&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__